module.exports = __webpack_public_path__ + "05_glasses_brown.79be5ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/05_glasses_brown.png
// module id = 6wO2
// module chunks = 0